/**
 * ImpressumPage — Pflichtangaben nach §5 DDG (ehem. §5 TMG) und §18 MStV.
 *
 * Zieht alle Daten aus data/company.js. Fehlen ladungsfähige Pflichtangaben, wird
 * das oben sichtbar angezeigt, damit das Impressum nicht unbemerkt unvollständig
 * online geht. Stellt keine Rechtsberatung dar (Owner-Direktive: in-house).
 */
import { company, addressLines, missingImpressumFields } from "@/data/company";

const ImpressumPage = () => {
  const missing = missingImpressumFields();
  const lines = addressLines();

  return (
    <div className="max-w-4xl mx-auto py-8 px-4">
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Impressum</h1>

        {missing.length > 0 && (
          <div className="mb-6 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
            <strong>Hinweis (nur intern sichtbar relevant):</strong> Vor dem Verkaufsstart
            müssen noch folgende Pflichtangaben in <code>data/company.js</code> ergänzt
            werden: {missing.join(", ")}.
          </div>
        )}

        <div className="prose prose-gray max-w-none">
          <h2 className="text-xl font-semibold mt-2 mb-3">Angaben gemäß § 5 DDG</h2>
          <p>
            {lines.map((l, i) => (
              <span key={i}>
                {i === 0 ? <strong>{l}</strong> : l}
                <br />
              </span>
            ))}
            {company.legalForm && <>Rechtsform: {company.legalForm}<br /></>}
          </p>

          {company.representative && (
            <>
              <h2 className="text-xl font-semibold mt-6 mb-3">Vertreten durch</h2>
              <p>{company.representative}</p>
            </>
          )}

          <h2 className="text-xl font-semibold mt-6 mb-3">Kontakt</h2>
          <p>
            E-Mail: <a className="text-fox-fire" href={`mailto:${company.email}`}>{company.email}</a><br />
            {company.phone && <>Telefon: {company.phone}<br /></>}
            {company.website && (
              <>Web: <a className="text-fox-fire" href={company.website} target="_blank" rel="noreferrer">{company.website}</a></>
            )}
          </p>

          {(company.registerCourt || company.registerNumber) && (
            <>
              <h2 className="text-xl font-semibold mt-6 mb-3">Registereintrag</h2>
              <p>
                {company.registerCourt && <>Registergericht: {company.registerCourt}<br /></>}
                {company.registerNumber && <>Registernummer: {company.registerNumber}</>}
              </p>
            </>
          )}

          {company.vatId && (
            <>
              <h2 className="text-xl font-semibold mt-6 mb-3">Umsatzsteuer-ID</h2>
              <p>
                Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz:<br />
                {company.vatId}
              </p>
            </>
          )}

          <h2 className="text-xl font-semibold mt-6 mb-3">
            Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
          </h2>
          <p>
            {(company.contentResponsible || company.representative) || "—"}
            {lines.length > 1 && (
              <>
                <br />
                {company.street}
                <br />
                {[company.zip, company.city].filter(Boolean).join(" ")}
              </>
            )}
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">EU-Streitschlichtung</h2>
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{" "}
            <a className="text-fox-fire" href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noreferrer">
              https://ec.europa.eu/consumers/odr/
            </a>
            . Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer
            Verbraucherschlichtungsstelle teilzunehmen.
          </p>

          <h2 className="text-xl font-semibold mt-6 mb-3">Haftung für Inhalte</h2>
          <p>
            Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen Seiten
            nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als
            Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
            Informationen zu überwachen.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ImpressumPage;
